import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Row, Col, Card } from 'react-bootstrap';

const KeywordsTable = (props) => {
  const settingsKeywordDatatable = props.settingsKeywordDatatable;
  const handleEditKeyword = props.handleEditKeyword;
  const handleDeleteKeyword = props.handleDeleteKeyword;

  return (
    <Row>
      <Col>
        <Card style={{ marginTop: '1%' }}>
          <Card.Header>Keywords</Card.Header>
          <Card.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Keyword</th>
                  <th>Options</th>
                  <th>Comments</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {settingsKeywordDatatable.map((keyword, index) => (
                  <tr
                    key={keyword.id || `keyword-${index}`}
                    onClick={() => handleEditKeyword(keyword)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{keyword.dropdownName}</td>
                    <td>
                      {keyword.options && keyword.options.length > 0 ? (
                        <>
                          {keyword.options
                            .slice(0, 15)
                            .map((opt) => opt.label)
                            .join(', ')}
                          {keyword.options.length > 5 && (
                            <span style={{ color: '#888' }}> +{keyword.options.length - 5} more</span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>{keyword.comments || ''}</td>
                    <td>{keyword.createdAt ? new Date(keyword.createdAt).toLocaleString() : ''}</td>
                    <td>{keyword.updatedAt ? new Date(keyword.updatedAt).toLocaleString() : ''}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteKeyword(keyword);
                        }}
                      >
                        <i className="fa fa-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
                {settingsKeywordDatatable.length === 0 && (
                  <tr key="no-results">
                    <td colSpan="6" align="center">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

KeywordsTable.propTypes = {
  settingsKeywordDatatable: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      dropdownName: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      comments: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
    })
  ).isRequired,
  handleEditKeyword: PropTypes.func.isRequired,
  handleDeleteKeyword: PropTypes.func.isRequired,
};

export default KeywordsTable;
